import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=2c880554&scoped=true"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=2c880554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c880554",
  null
  
)

export default component.exports